FiltersMdl.directive( "scrollTo", ['$window', function( $window ) {
	return {
		restrict: 'A',
		link: function( scope, element ) {
			element.bind('change', function(){

				if( $window.innerWidth > 1024 )
					return;

				$('html, body').animate({ scrollTop: angular.element( this ).offset().top }, 800);
			})
		}
	}
}]);
